import { render, staticRenderFns } from "./FooterCustom.vue?vue&type=template&id=56b0cd1c&scoped=true&"
import script from "./FooterCustom.vue?vue&type=script&lang=js&"
export * from "./FooterCustom.vue?vue&type=script&lang=js&"
import style0 from "./FooterCustom.vue?vue&type=style&index=0&id=56b0cd1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0cd1c",
  null
  
)

export default component.exports